import {ProtectedRoute} from './protectedRoute';

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/components/common/ProtectedRoute/index.js